import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import './hall-editor.css';

/** @class HallMetadata
  * A component for editing the metadata of a hall
  * in a virtual expo.
  */
export default class HallMetadata extends Component {
  /** @constructor
    * Creates a new instance of the component.
    */
  constructor(props) {
    super(props);
    this.state = {
      name: props.name || "Unnamed Hall",
      published: props.published || false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  /** @function handleChange
    * Updates the component state to reflect changes
    * in input fields.
    * @param {InputEvent} event - the change event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @function handleBlur
    * Applies the updated state to the firebase database
    */
  handleBlur(event) {
    const target = event.target;
    const name = target.name;
    firebase.database().ref(this.props.dataURL).child(name).set(this.state[name]);
  }
  /** @function render
    * renders the component.
    */
  render() {
    return (
      <div className="metadata-panel">
        <div className="metadata-column">
          <div className="input-group">
            <label htmlFor="name">Name</label><br/>
            <input type="text" name="name"
              value={this.state.name}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />
          </div>
          <div className="input-group">
            <label htmlFor="published">
            <input type="checkbox" name="published"
              checked={this.state.published}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />
              Published
            </label>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/hall-editor/hall-metadata.js